//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let outerHeight = 'auto';
	let hrWidth = '110%';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
		outerHeight = 'auto';
		hrWidth = '100';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				height: outerHeight,
				width: '100%',
				backgroundColor: '#CCAD8F',
				marginTop: mt ? `3rem` : `unset`,
			};
		},
		contentContainerStyle: () => {
			return {
				width: 'auto',
				height: 'auto',
				margin: 'auto',
				padding: `3rem ${minimumMarginX}rem`,
			};
		},
		titleStyle: () => {
			return {
				color: 'black',
				marginBottom: '1rem',
			};
		},
		dayRow: () => {
			return {
				display: 'flex',
				flexDirection: 'column',
			};
		},
		textContentContainerStyle: () => {
			return {
				display: 'flex',
			};
		},
		textStyle: () => {
			return {};
		},
		textClasses: () => {
			let classes = 'col-6';

			return classes;
		},
		hrStyle: () => {
			return {
				margin: `1rem 0`,
				width: hrWidth,
			};
		},
		hrClasses: () => {
			let classes = '';
			return classes;
		},
	};
}

export default Styles;
